module.exports = __webpack_public_path__ + "static/media/icon_tel.a9b52ef3.svg";